import React from "react";

const ButtonTextNoLink = ({ className, text = "Learn More" }) => {
  return <h6 className={`${className} h-6 ttu mb0 tc`}>{text}</h6>;
};

export default ButtonTextNoLink;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonTextNoLink.js